import * as React from "react";
import styles from "./V3BrandLockup.module.scss";
/*
  uncomment this line to import the medLogo image if needed.
  import medLogo from "images/new_med_logo.svg";
*/
import medLogo from "images/med_logo_twenty_five_years.svg";

interface V3BrandLockupProps {
  cobrandedLogoUrl?: string;
  vintageName?: string;
}

export const V3BrandLockup: React.FC<V3BrandLockupProps> = ({
  cobrandedLogoUrl,
  vintageName,
}) => (
  <a
    href="https://www.myeyedr.com/"
    className={styles.link}
    aria-label="MyEyeDr. homepage"
  >
    <span className={styles.lockup}>
      <span
        className={
          cobrandedLogoUrl
            ? styles.cobrandedLogoContainer
            : styles.vintageNameContainer
        }
      >
        {cobrandedLogoUrl ? (
          <img
            src={cobrandedLogoUrl}
            className={styles.cobrandedLogo}
            alt="Partner logo"
          />
        ) : (
          <span
            className={styles.vintageName}
            title={vintageName}
            aria-label={vintageName}
          >
            {vintageName}
          </span>
        )}
      </span>
      <span
        className={styles.divider}
        data-testid="cobranded-logo-divider"
        aria-hidden="true"
      />
      <span className={styles.myEyeDrContainer}>
        <span className={styles.tagline}>Now a part of</span>
        <img src={medLogo} className={styles.myEyeDrLogo} alt="MyEyeDr. logo" />
      </span>
    </span>
  </a>
);